import { render } from "./AdOrderTaxInvoice.vue?vue&type=template&id=ffe49040"
import script from "./AdOrderTaxInvoice.vue?vue&type=script&lang=js"
export * from "./AdOrderTaxInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__